var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"square-img",class:_vm.classes,on:{"click":function($event){return _vm.$emit('click')}}},[(_vm.rollover)?_c('div',{staticClass:"square-img__mask"}):_vm._e(),_c('BaseImg',{attrs:{"src":_vm.src}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }